import {
    GETUSERNAMECONTACTSUGGESTIONFORADMIN_SUCCESS,
    GETUSERNAMECONTACTSUGGESTIONFORADMIN_FAILED,
    RESET_GETUSERNAMECONTACTSUGGESTIONFORADMIN,
    LOADING_GETUSERNAMECONTACTSUGGESTIONFORADMIN,
    NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTIONFORADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUSERNAMECONTACTSUGGESTIONFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETUSERNAMECONTACTSUGGESTIONFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETUSERNAMECONTACTSUGGESTIONFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTIONFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETUSERNAMECONTACTSUGGESTIONFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};